export default {"src":"/_next/static/media/coco-reading-book.a74656fb.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};